import axios from 'axios';
import { ApiRoutes } from '../ApiRoutes';
import { AxiosResponse } from 'axios'
import {
  SendActivationCodeRequest,
  SendActivationCodeResponse,
  ValidateActivationCodeRequest, 
  ValidateActivationCodeResponse,
  GrantLoginPermissionsRequest,
  GrantLoginPermissionsResponse
} from '@/types/webContracts';

export async function sendVerificationCode(params: SendActivationCodeRequest): Promise<AxiosResponse<SendActivationCodeResponse>> {
  const result = await axios.post(ApiRoutes.Auth.SendVerificationCode, params);
  return result;
}

export async function validateVerificationCode(params: ValidateActivationCodeRequest): Promise<AxiosResponse<ValidateActivationCodeResponse>> {
  const result = await axios.post(ApiRoutes.Auth.ValidateVerificationCode, params);
  return result;
}

export async function grantLoginPermissions(params: GrantLoginPermissionsRequest): Promise<AxiosResponse<GrantLoginPermissionsResponse>> {
  const result = await axios.post(ApiRoutes.Auth.GrantLoginPermissions, params);
  return result;
}